import { render, staticRenderFns } from "./HighlightedText.vue?vue&type=template&id=18b5ff50"
import script from "./HighlightedText.vue?vue&type=script&lang=js"
export * from "./HighlightedText.vue?vue&type=script&lang=js"
import style0 from "./HighlightedText.vue?vue&type=style&index=0&id=18b5ff50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports